import { helpers } 		from '../helpers.js';

var animateBlocks = {
	selectors: [
		".gallery__item",
		".cards .cards__one",
		".two-columns .row div"
	],

	init: function () {
		var self = this;

		if( ! jQuery( 'body' ).hasClass( 'allow-animate-blocks' ) )  {
			return false;
		}

		jQuery( self.selectors ).each( function() {
			if( jQuery(this).length ) {
				if( helpers.isOnScreen( jQuery( this ) ) ) {
					jQuery( this ).attr( 'data-show', 1 );
				}
			}
		});
	},
};

export { animateBlocks };
